// Lightweight client-side wishlist: stores product handles in localStorage.
// No account/cart dependency, so it works before a customer signs in.
(function () {
  const STORAGE_KEY = 'crockera_wishlist';

  function getHandles() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveHandles(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handles } }));
  }

  function isSaved(handle) {
    return getHandles().includes(handle);
  }

  function toggle(handle) {
    const handles = getHandles();
    const index = handles.indexOf(handle);
    if (index === -1) handles.push(handle);
    else handles.splice(index, 1);
    saveHandles(handles);
    return index === -1;
  }

  function updateButtonState(button) {
    const handle = button.dataset.wishlistHandle;
    button.classList.toggle('wishlist-button--active', isSaved(handle));
    button.setAttribute('aria-pressed', isSaved(handle) ? 'true' : 'false');
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-handle]').forEach(updateButtonState);
  }

  function updateCountBadges() {
    const count = getHandles().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-handle]');
    if (!button) return;
    event.preventDefault();
    toggle(button.dataset.wishlistHandle);
  });

  document.addEventListener('wishlist:change', () => {
    updateAllButtons();
    updateCountBadges();
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateAllButtons();
    updateCountBadges();
  });

  window.CrockeraWishlist = { getHandles, isSaved, toggle };
})();
